var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"filter__group"},[(_vm.titlePosition === 'top')?_vm._t("group-title"):_vm._e(),_vm._v(" "),_vm._t("group-content"),_vm._v(" "),(_vm.titlePosition === 'bottom')?_vm._t("group-title"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }